import { combineReducers } from "@reduxjs/toolkit";
import { reducer as authReducer } from "./auth/slice";
import { reducer as assistantReducer } from "./assistant/slice";
import { reducer as dataRoomFileReducer } from "./dataRoomFile/slice";
import { reducer as presenceReducer } from "./presence/slice";
import { reducer as dataRoomReducer } from "./data-room/slice";
import { reducer as dealSearchReducer } from "./deal-search/slice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  whitelist: [
    "accessToken",
    "isLoggedIn",
    "account",
    "activeDealId",
    "dealsLastSeen",
    "navigationCollapsed",
  ],
};

const dataRoomPersistConfig = {
  key: "dataRoom",
  storage: storage,
  whitelist: ["view"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  assistant: assistantReducer,
  dataRoomFile: dataRoomFileReducer,
  presence: presenceReducer,
  dealSearch: dealSearchReducer,
  dataRoom: persistReducer(dataRoomPersistConfig, dataRoomReducer),
});

export default rootReducer;
